// Hooks
import React from 'react';
import { useDispatch } from 'react-redux';

// Common style components
import { StyledDashedSeparator } from '../../common/styles/Separators';
import { StyledLabel } from '../../common/styles/devices/Labels';
import { StyledTextInput } from '../../common/styles/devices/Texts';

// Common field components
import { StandardSelector, DaySelector } from '../../common/fields/devices/Selector';
import { Row, Column } from '../../common/fields/PageUtils';
import { SaveButton } from '../../common/fields/devices/Buttons';
import { StandardEditDisplayMessage } from '../../common/fields/devices/DisplayMessages';
import { messages_common, messages_reboot } from '../../common/types/Messages';
import { StyledEditPanelContainer } from '../../common/styles/devices/Container';

// Store
import { editNodeRebootDetail, updateNodeToDb } from '../../../store/positions/menuNodesSlice';
import { EditRebootDetail } from '../../../store/positions/types';

// Other
import moment from 'moment';

export function EditPanel({ node }: {node: EditRebootDetail}) {
  
  const dispatch = useDispatch();
  
  return (
    <StyledEditPanelContainer>      
      
      <StyledTextInput
        disabled={true}
        value='Weekly Restart'
      />         
      
      <Row>
        <Column>
          <StyledLabel>Restart At</StyledLabel>
          <StandardSelector 
            parameter={node.dtstart} 
            onChange={(select_event) => dispatch(editNodeRebootDetail({ id: node.id, dtstart: moment(node.dtstart).hours(select_event.target.value).format('YYYY-MM-DD HH:mm:ss')})) }
            array={Array.from(Array(25).keys())}
            type='Hour'
          />
        </Column>   
      </Row>
        
      <Row>
        <DaySelector 
          selected={node.byweekday} 
          labels={['M', 'T', 'W', 'T', 'F', 'S', 'S']} 
          onChange={(select_event) => dispatch(editNodeRebootDetail({id: node.id, byweekday: select_event.selected}))}
          type='DaySingle'
        />
      </Row>        
        
      <Row>                
        <SaveButton margin='0 55%' disabled={(node.saved)} onClick={() => {dispatch(updateNodeToDb(node))}} text="Save"/>        
      </Row>  

      <StyledDashedSeparator/>     

      <Row>
        <StandardEditDisplayMessage message={messages_common.save}/>
      </Row>  
      
      <Row>
        <StandardEditDisplayMessage message={messages_reboot.description}/>
      </Row>

      <Row>
        <StandardEditDisplayMessage message={messages_reboot.limitation}/>
      </Row>

    </StyledEditPanelContainer>
  );
}

